import { AutogenModelMovementOrderLookup, AutogenRowMovementOrderLookup } from "./autogen/AutogenModelMovementOrderLookup";

export class ModelMovementOrderLookup extends AutogenModelMovementOrderLookup<RowMovementOrderLookup> {
	constructor() {
		super(RowMovementOrderLookup);
	}
}

export class RowMovementOrderLookup extends AutogenRowMovementOrderLookup {
}